import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../common/withRouter';
import {
  DataDefinitionList,
  Loader,
  Notification,
  Message
} from '../../web.common';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import withApi from '../higherOrderComponents/withApi';
import {
  DisplayDate,
  DisplayGuid
} from '../items';
import { DetailsRightBar, NoLink, Divider } from './DetailsRightBar';

class ActivityInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activityData: null
    };
  }

  async componentDidMount() {
    const { match: { params: { activityId } } } = this.props;
    const { api: { activities: { getActivity } } } = this.props;

    try {
      const activityData = await getActivity(activityId);
      this.setState({ activityData });
    }
    catch (e) {
      this.setState({ errorMessage: new Message('error', 'Unable to get data') });
    }
  }

  render() {
    const { match: { params: { activityId } } } = this.props;
    const { activityData, errorMessage } = this.state;

    let mappedData = null;

    if (activityData) {
      const {
        id,
        createdAt,
        title,
        spotIndex,
        productId,
        crawlingId,
        externalActivityId = '',
        facilityId = '',
        startsAt,
        endsAt,
        externalReference = '',
        isBuried,
        isShadowed,
        signups
      } = activityData;

      mappedData = {
        Id: <DisplayGuid>{id}</DisplayGuid>,
        'Created At': <DisplayDate>{createdAt}</DisplayDate>,
        title,
        spotIndex,
        'Product Id': <DisplayGuid baseAnchor='/product/details'>{productId}</DisplayGuid>,
        'Crawling Id': <DisplayGuid baseAnchor='/crawling'>{crawlingId}</DisplayGuid>,
        'Facility Id': <DisplayGuid baseAnchor='/facility'>{facilityId}</DisplayGuid>,
        'External Activity Id': externalActivityId ? 
          <DisplayGuid baseAnchor='/externalactivity'>{externalActivityId}</DisplayGuid> : 
          '',
        'Starts At': <DisplayDate>{startsAt}</DisplayDate>,
        'Ends At': <DisplayDate>{endsAt}</DisplayDate>,
        'External Reference': externalReference ?? '',
        isBuried,
        isShadowed,
        signups: signups && signups.length > 0 ? 
          <ul> 
            { 
              signups.map(({ id: signupId, status }) => 
                <li>
                  <DisplayGuid baseAnchor='/signup'>{signupId}</DisplayGuid>
                  <span>, status = {status}</span>
                </li>) 
            }
          </ul> : 
          ''
      };
    }

    return (
      <LayoutContext.Consumer>
        {() => (
          <React.Fragment>
            <Notification newMessage={errorMessage} />

            <div className='content-with-right-pane-delimiter'>
              <PageTop
                documentTitle='Activity details'
                documentDescription='Activity details'
              />

              <h2 className='main-page-header main-page-header-with-subheader'>
                Activity
              </h2>
              <h5 className='main-page-subheader'>{activityId}</h5>
              <br />

              {
                mappedData ? (
                  <React.Fragment>
                    <DataDefinitionList
                      listData={mappedData}
                      classNames={['detail-page-list']}
                    />
                  </React.Fragment>
                ) : <Loader hasLoaded={false}>Loading...</Loader>
              }
            </div>

            <DetailsRightBar>
              <Divider>Links</Divider>
              <NoLink>None</NoLink>
              <Divider>Actions</Divider>
              <NoLink>None</NoLink>
            </DetailsRightBar>
          </React.Fragment>
        )}
      </LayoutContext.Consumer>
    );
  }
}

const Activity = withRouter(withApi(connect(({ user }) => ({ isLoggedIn: !!user }), {})(ActivityInternal)));

Activity.requiresLogin = true;
Activity.propTypes = { isLoggedIn: PropTypes.bool };

export default Activity;